export default __webpack_public_path__ + "static/media/wolfez.2d3050e8.gif";